/**
 * Count visible characters in LaTeX string
 * Excludes LaTeX commands and control sequences
 *
 * @param latex LaTeX string
 * @param ignoreSpaces If true, trim spaces before counting
 * @returns Number of visible characters
 */
// export function countVisibleCharsInLatex(latex: string, ignoreSpaces = false): number {
//   if (!latex) return 0;
//   // Remove LaTeX commands and control sequences
//   // This regex matches:
//   // - \command{...} style commands
//   // - \command style commands
//   // - Multiple spaces
//   let cleaned = latex
//     // Remove \command{...} style (including nested braces)
//     .replace(/\\[a-zA-Z]*\{[^}]*\}/g, '')
//     // Remove remaining \command style
//     .replace(/\\[a-zA-Z]*\s*/g, '')
//     // Remove special LaTeX characters that don't display
//     .replace(/[\{\}]/g, '')
//     // Remove multiple spaces (but keep single spaces as they might be meaningful)
//     .replace(/\s+/g, ' ');
//   if (ignoreSpaces) {
//     cleaned = cleaned.trim();
//   }
//   return cleaned.length;
// }
var extractBracedContent = function (str, startPos) {
    var depth = 1;
    var pos = startPos + 1;
    var content = '';
    while (pos < str.length && depth > 0) {
        if (str[pos] === '\\' &&
            pos + 1 < str.length &&
            (str[pos + 1] === '{' || str[pos + 1] === '}')) {
            content += str[pos] + str[pos + 1];
            pos += 2;
        }
        else if (str[pos] === '{') {
            depth++;
            content += '{';
            pos++;
        }
        else if (str[pos] === '}') {
            depth--;
            if (depth > 0)
                content += '}';
            pos++;
        }
        else {
            content += str[pos];
            pos++;
        }
    }
    return { content: content, endPos: pos - 1 };
};
export var countVisibleCharsInLatex = function (latex, ignoreSpaces) {
    if (ignoreSpaces === void 0) { ignoreSpaces = false; }
    if (!latex)
        return 0;
    var count = 0;
    var i = 0;
    if (ignoreSpaces && ['\\,', '\\:', '\\;'].includes(latex[i])) {
        return 0;
    }
    while (i < latex.length) {
        if (latex.substring(i).startsWith('\\frac{')) {
            var numStart = i + 5;
            var numResult = extractBracedContent(latex, numStart);
            var numCount = countVisibleCharsInLatex(numResult.content);
            var denStart = numResult.endPos + 1;
            if (latex[denStart] === '{') {
                var denResult = extractBracedContent(latex, denStart);
                var denCount = countVisibleCharsInLatex(denResult.content);
                count += Math.max(numCount, denCount);
                i = denResult.endPos + 1;
            }
            else {
                i = numResult.endPos + 1;
            }
            continue;
        }
        if (latex[i] === '^') {
            i++;
            if (i < latex.length) {
                if (latex[i] === '{') {
                    var powerResult = extractBracedContent(latex, i);
                    var powerCount = countVisibleCharsInLatex(powerResult.content);
                    count += powerCount;
                    i = powerResult.endPos + 1;
                }
                else {
                    count += 1;
                    i++;
                }
            }
            continue;
        }
        if (latex[i] === '_') {
            i++;
            if (i < latex.length) {
                if (latex[i] === '{') {
                    var subResult = extractBracedContent(latex, i);
                    var subCount = countVisibleCharsInLatex(subResult.content);
                    count += subCount;
                    i = subResult.endPos + 1;
                }
                else {
                    count += 1;
                    i++;
                }
            }
            continue;
        }
        if (latex[i] === '\\') {
            var commandEnd = i + 1;
            while (commandEnd < latex.length && /[a-zA-Z]/.test(latex[commandEnd])) {
                commandEnd++;
            }
            var commandName = latex.substring(i + 1, commandEnd);
            // Non-alphabetic commands like \, \: \; \! \> (spacing) or \\ (newline)
            // \$ and \% are visible characters — count them as 1
            if (commandName === '' && commandEnd < latex.length) {
                var nextChar = latex[commandEnd];
                if (nextChar === '$' || nextChar === '%') {
                    count += 1;
                }
                i = commandEnd + 1; // skip the backslash + the next character
                continue;
            }
            // \placeholder{} counts as 1 visible box
            if (commandName === 'placeholder') {
                count += 1;
                if (commandEnd < latex.length && latex[commandEnd] === '{') {
                    var contentResult = extractBracedContent(latex, commandEnd);
                    i = contentResult.endPos + 1;
                }
                else {
                    i = commandEnd;
                }
                continue;
            }
            // Zero-width/invisible commands (spacing, phantoms)
            var invisibleCommands = ['quad', 'qquad', 'hspace', 'vspace', 'kern', 'phantom', 'hphantom', 'vphantom'];
            if (invisibleCommands.includes(commandName)) {
                if (commandEnd < latex.length && latex[commandEnd] === '{') {
                    var contentResult = extractBracedContent(latex, commandEnd);
                    i = contentResult.endPos + 1;
                }
                else {
                    i = commandEnd;
                }
                continue;
            }
            if (commandEnd < latex.length && latex[commandEnd] === '{') {
                var contentResult = extractBracedContent(latex, commandEnd);
                if (commandName === 'text') {
                    count += contentResult.content.length;
                }
                else {
                    var contentCount = countVisibleCharsInLatex(contentResult.content);
                    count += contentCount;
                }
                i = contentResult.endPos + 1;
            }
            else {
                count += 1;
                i = commandEnd;
            }
            continue;
        }
        if (!/[\s{}]/.test(latex[i])) {
            count++;
        }
        i++;
    }
    return count;
};
